import React from 'react';
import { useConsentConfiguration, useSettings } from '../../hooks/queryHooks';
import { EDataSources } from '../../constants/EDataSources';
import PermissionClustersAccordion from '../../containers/consent/PermissionClustersAccordion';
import IdCoTerms from './IdCoTermsContent';
import YapilyDisclaimer from '../yapily/YapilyDisclaimer';
import { useAppState, useSelectedProvider } from '../../hooks/zustandHooks';
import getReplacementTokens from '../../utils/GetReplacementTokens';
import RecaptchaDisclaimer from '../recaptcha/RecaptchaDisclaimer';
import DefaultDisclaimer from '../defaultDisclaimer/DefaultDisclaimer';

const ConsentLegalInfo = () => {
  const { settings } = useSettings();
  const { appState } = useAppState();

  const dataSource = useSelectedProvider(state => state.selectedProvider?.dataSource);
  const { useValidationToken } = appState;

  const { consentConfiguration } = useConsentConfiguration();
  const replacementTokens = getReplacementTokens(consentConfiguration);
  const showYapilyDisclaimer = dataSource === EDataSources.YAPILY;

  const idCoTerms = {
    consentText: consentConfiguration?.terms?.termText || null,
    consentDate: consentConfiguration?.consentEndDate
  };

  return (
    <>
      {!consentConfiguration?.isImplicit && (
        <>
          <PermissionClustersAccordion replacementTokens={replacementTokens} />
          <IdCoTerms {...idCoTerms} />
        </>
      )}
      <div
        className={`text-justify ${
          settings?.legal?.disableDefaultDisclaimer ?? showYapilyDisclaimer ? 'mt-0' : 'mt-8'
        }`}
      >
        {settings?.legal?.disableDefaultDisclaimer !== false && showYapilyDisclaimer ? (
          <YapilyDisclaimer />
        ) : (
          <DefaultDisclaimer />
        )}

        {!useValidationToken && <RecaptchaDisclaimer />}
      </div>
    </>
  );
};

export default ConsentLegalInfo;
